export const API = {
  // Setting
  SETTING: "/setting",
  ADMIN_SETTING: "/admin/setting",

  // Application
  TEMPLATE: "/application/section",
  SUBMIT: "/application/submit",

  // Result
  APPLICATION_RESULT: "/result/getDisplay",
  USER_DETAIL: "/result/get",
  USER_LOGIN: "/result/login",
  USER_LOGOUT: "/result/logout",
  USER_PAYMENT: "/result/payment/get",
  USER_RECEIPT: "/result/receipt",

  ALIPAY_QR_REQUEST: "/payment/alipay/qrcode",
  ALIPAY_QR_STATUS: "/payment/alipay/status",
  ALIPAY_WEB_REQUEST: "/payment/alipay/web",
  ALIPAY_SUCCESS: "/payment/alipay/success",

  FPS_QR_REQUEST: "/payment/fps/qrcode",

  CUSTOM_HTML: "/payment/custom/html",

  // Admin Login
  ADMIN_LOGIN: "/admin/login",
  ADMIN_LOGOUT: "/admin/logout",
  ADMIN_ME: "/admin/me",

  // Admin Program
  PROGRAM_CLONE: "/admin/program/clone",
  PROGRAM_DELETE: "/admin/program/delete",
  PROGRAM_DETAIL: "/admin/program/:id",
  PROGRAM_LIST: "/admin/program",
  PROGRAM_UPDATE: "/admin/program/update",

  // Application Section
  TEMPLATE_EXPORT: "/admin/section/export",
  TEMPLATE_IMPORT: "/admin/section/import",
  TEMPLATE_VIEW: "/admin/section",

  // Application result
  APPLICATION_DETAIL: "/admin/result/:applicationNumber",
  APPLICATION_IMPORT: "/admin/result/import",
  APPLICATION_LIST_CONFIG: "/admin/result/list/configuration",
  APPLICATION_LIST: "/admin/result",
  PAYMENT_GET: "/admin/result/payment/:applicationNumber",
  PAYMENT_UPDATE: "/admin/result/payment/update",
  ADMIN_RECEIPT: "/admin/result/receipt/:applicationNumber",
  APPLICATION_UPDATE: "/admin/result/update",

  ADMIN_FILE_UPLOAD: "/admin/file/upload",
  ADMIN_REPORT_DOWNLOAD: "/admin/report/download",
};

export const PAGE = {
  INDEX: "/",
  ERROR: "/error",
  APP: "/app/:pid",
  LANDING: "/app/:pid/landing",
  APPLICATION: "/app/:pid/application",
  APPLICATION_CONFIRM: "/app/:pid/confirmation",
  APPLICATION_RESULT: "/app/:pid/result",

  // User portal
  USER_LOGIN: "/app/:pid/user",
  USER_APPLICATION_DETAIL: "/app/:pid/user/application",
  USER_PAYMENT: "/app/:pid/user/payment",
  USER_ACTIVITY_LOG: "/app/:pid/user/activityLog",

  ALIPAY: "/app/:pid/alipay",
  FPS: "/app/:pid/fps",
  CUSTOM_HTML: "/app/:pid/other",

  // Admin portal
  ADMIN_LOGIN: "/admin",
  ADMIN_PROGRAM_LIST: "/admin/program/list",
  ADMIN_PROGRAM_DETAIL: "/admin/program/:pid",
  ADMIN_PROGRAM_DETAIL_EDIT: "/admin/program/:pid/edit",
  ADMIN_APPLICATION_DETAIL: "/admin/program/:pid/application/:id",
  ADMIN_APPLICATION_EDIT: "/admin/program/:pid/application/:id/edit",
  ADMIN_PAYMENT_EDIT: "/admin/program/:pid/application/:id/payment/edit",

  ADMIN_APPLICATION_IMPORT: "/admin/import",
  ADMIN_SETTING: "/admin/setting",

  // Both
  CERTIFICATE: "/certificate/:portal/:pid/:id",
  RECEIPT: "/receipt/:portal/:pid/:id",
};

// export const paymentMethodOptions = ['cash', 'cheque', 'alipay'];
// export const paymentMethodOptions = [
//   { id: "cash", enable: true },
//   { id: "cheque", enable: true },
//   { id: "alipay", enable: false },
//   { id: "fps", enable: true },
// ];

export const TIME_FORMAT = "YYYY/MM/DD hh:mm a";
